// extracted by mini-css-extract-plugin
module.exports = {"stepCountLabel":"SticksFormStepSection_stepCountLabel__Ehe7u","title":"SticksFormStepSection_title__bDJJ1","contentWrapper":"SticksFormStepSection_contentWrapper__ymF5O"};